import * as Yup from 'yup';
import { ajustesGlobalesIaFormModel } from './ajustesGlobalesIaFormModel';

const {
    formField: {
        creditsPerUsd,
        defaultTemperature,
        defaultTopP,
        defaultMaxTokens
    }
} = ajustesGlobalesIaFormModel;

export const validationSchema = [
    Yup.object().shape({
        [creditsPerUsd.name]: Yup.number()
            .nullable()
            .min(0, 'El valor no puede ser negativo')
            .typeError('Debe ser un número'),
        [defaultTemperature.name]: Yup.number()
            .nullable()
            .min(0, 'La temperatura mínima es 0')
            .max(2, 'La temperatura máxima es 2')
            .typeError('Debe ser un número'),
        [defaultTopP.name]: Yup.number()
            .nullable()
            .min(0, 'El mínimo es 0')
            .max(1, 'El máximo es 1')
            .typeError('Debe ser un número'),
        [defaultMaxTokens.name]: Yup.number()
            .nullable()
            .integer('Debe ser un número entero')
            .min(1, 'Debe ser mayor a 0')
            .max(131072, 'Supera el límite máximo de tokens')
            .typeError('Debe ser un número')
    })
];
